import React from 'react'
import {Flex} from '/app/src/component'
import style from './style.css'
import {NavLink} from 'react-router-dom'
import SVG from 'react-inlinesvg';
class SubItem extends React.Component {
    render(){
        let text = this.props.text
        let icon = this.props.imgSrc ?
        <img className={style.ItemIcon} alt='' src={this.props.imgSrc}/>
        : <SVG cacheGetRequests={true} style={{fill: this.props.svgfill}} className={style.ItemIcon} src={this.props.svgSrc} />

        return (
            <NavLink to={this.props.to} activeClassName={style.MenuSubItemSelected} className={style.MenuSubItem}>
                <Flex height='100%'>
                    <Flex hAlignContent='center' vAlignContent='center' basis='30%'>
                    {icon}
                    </Flex>
                    <Flex grow hAlignContent='left' vAlignContent='center' color='#404040'>
                        {text}
                    </Flex>
                </Flex>
            </NavLink>
        )
    }
}

export default SubItem;



// WEBPACK FOOTER //
// ./src/component/Menu/SubItem.js